import "./footer.css";
import { FaFacebook, FaLinkedin, FaInstagram } from "react-icons/fa";

import {
  FaXTwitter,
  FaArrowRightLong,
  FaCartPlus,
  FaHeart,
  FaLocationDot,
} from "react-icons/fa6";
import { PiArrowLineUpBold } from "react-icons/pi";
import { IoMdMail } from "react-icons/io";

const Footer = ({ scrollContainerRef, isScrolled }) => {
  const scrollToTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div className="footer">
      {isScrolled && (
        <div className="topbtn" onClick={scrollToTop}>
          <PiArrowLineUpBold className="icon" />
          <span className="topbtn-text">Back to Top</span>
        </div>
      )}

      <div className="footer-container">
        <div className="mission">
          <h3>Useful Links</h3>
          <ul className="ullist">
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              About Us
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Contact Us
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Careers
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Industries
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Corporate Information
            </li>
          </ul>
        </div>

        <div className="mission">
          <h3>Online Shopping</h3>
          <ul className="ullist">
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Men
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Women
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Kids
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Electronics
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Home & Appliances
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Furniture
            </li>
          </ul>
        </div>

        <div className="mission">
          <h3>Customer Policies</h3>
          <ul className="ullist">
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Contact Us
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Track Order
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Terms & Conditions
            </li>
            <li className="lists">
              <span className="footericon">
                <FaArrowRightLong />
              </span>{" "}
              Cancellation & Returns
            </li>
          </ul>
        </div>

        <div className="second-row">
          <div className="mission">
            <h3>About Us</h3>
            <p>
              Ambrosys Business Solutions Pvt Ltd is a business consulting and
              IT services firm offering solutions in infrastructure, HR
              services, BPO, and more.
            </p>
          </div>

          <div className="mission">
            <h3>Customer Policies</h3>
            <ul className="ullist12">
              <li className="lists12">
                <span className="footericon">
                  <FaArrowRightLong />
                </span>{" "}
                Cart <FaCartPlus />
              </li>
              <li className="lists12">
                <span className="footericon">
                  <FaArrowRightLong />
                </span>{" "}
                Whsihlist <FaHeart />
              </li>
            </ul>
          </div>

          <div className="address">
            <h3>Address</h3>
            <a href="mailto:info@ambrosyscorp.com">
              <IoMdMail /> info@ambrosyscorp.com
            </a>
            <p>
              <FaLocationDot /> Ambrosys Business Solutions Pvt Ltd
              <br />
              2nd Floor, ABC Building,
              <br />
              Chennai, Tamil Nadu – 600001
              <br />
              India
            </p>
          </div>
        </div>
      </div>

      <div className="social-icons centered">
        <a
          href="https://facebook.com/LayamGroup"
          target="blank"
          rel="noopener noreferrer"
          className="fbook"
        >
          <FaFacebook />
        </a>
        <a
          href="https://linkedin.com/company/layam-management-solutions-pvt-ltd"
          target="blank"
          rel="noopener noreferrer"
          className="linkin"
        >
          <FaLinkedin />
        </a>
        <a
          href="https://x.com/LayamGroup"
          target="blank"
          rel="noopener noreferrer"
          className="twitter"
        >
          <FaXTwitter />
        </a>
        <a
          href="https://www.instagram.com/ambrosyscorp/"
          target="blank"
          rel="noopener noreferrer"
          className="instagram"
        >
          <FaInstagram />
        </a>
      </div>

      <div className="line"></div>

      <div className="RENO">
        <p>&copy; Copyright 2025 Reno HR. All Rights Reserved.</p>
      </div>

      <div className="company">
        <div>
          Developed by
          <span>
            <a href="https://ambrosyscorp.com/" target="blank" className="abs">
              AMBROSYS
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Footer;
